import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { CallbackComponent } from './modules/auth/auth-callback/auth-callback.component';
import { SupplierGuard } from './core/auth/guards/supplier.guard';
import { CombinedGuard } from './core/auth/guards/combine.guard';

export const appRoutes: Route[] = [

    // Redirect the exact root path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'sign-in' },

    // Redirect signed-in user to the '/example'
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'fornitori' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') },
        ]
    },

    // Admin routes
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'dense'
        },
        children: [
            { path: 'analytics', canActivate: [CombinedGuard], loadChildren: () => import('app/modules/admin/analytics/analytics.routes') },
            { path: 'fornitori', canActivate: [CombinedGuard], loadChildren: () => import('app/modules/admin/suppliers/suppliers.routes') },
            { path: 'report', canActivate: [CombinedGuard], loadChildren: () => import('app/modules/admin/report/report.routes') },
            { path: 'contracts', canActivate: [CombinedGuard], loadChildren: () => import('app/modules/admin/contracts/contracts.routes') },
            { path: 'outsourcing-register', canActivate: [CombinedGuard], loadChildren: () => import('app/modules/admin/outsourcing-register/outsourcing-register.routes') },
            { path: 'auditing', canActivate: [CombinedGuard], loadChildren: () => import('app/modules/admin/accesses/accesses.routes') },
            { path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes') }
        ]
    },

    // Aggiungi la rotta di callback per Microsoft login
    {
        path: 'callback',  // Questo è l'endpoint che Microsoft reindirizza
        component: CallbackComponent,  // Il componente che gestisce il token e fa il redirect
        pathMatch: 'full'
    },

    // Gestione degli URL non trovati (404)
    { path: '**', redirectTo: 'sign-in' }

];
